/**
 * Espera en curso de un stream de IA (OT-0040). El backend manda `waiting`
 * cada 15 s sin otro evento; cualquier otro evento significa que hubo
 * progreso. Fuente única para los cuatro flujos (sección, "generar todo",
 * proponer estructura, IA de comentarios).
 */

import type { WaitingPayload } from '../api/agents'
import type { SseEvent } from '../api/client'

export function aiWaitingFrom(event: SseEvent): WaitingPayload | null {
  return event.type === 'waiting' ? (event.payload as WaitingPayload) : null
}
